module.exports = __webpack_public_path__ + "img/battery_red.12dd9ece.svg";